module.exports = __webpack_public_path__ + "static/img/resource_widget_2.72c0db4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/resource_widget_2.png
// module id = u8XV
// module chunks = 11